import { Component, OnInit, Input } from '@angular/core';
import { ImageUploadService } from '@app/services/image-upload/image-upload.service';
import { take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectImageProfleImageState } from '@app/modules/image/store/selectors/image.selectors';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss']
})
export class ProfileImageComponent implements OnInit {
  public subs: SubSink = new SubSink();
  public profileImage$: String = ''
  public isLoading$: boolean = true;

  constructor(
    private store$: Store
  ) { }
  // this.defaultProfileImageUrl = `https://ui-avatars.com/api/?size=128&name=${val}`;

  ngOnInit(): void {
    this.subs.add(this.store$.select(selectImageProfleImageState).subscribe(res => {
      this.profileImage$ = res;
      this.isLoading$ = false;
    }))
  }

}
